
import { mapState, mapGetters } from "vuex";
import noDataLabel from "../common/no-data-label.vue";
export default {
  components: { noDataLabel },
  data() {
    return {
      selectedOption: "",
      items: [
        { value: "high", label: "High" },
        { value: "medium", label: "Medium" },
        { value: "low", label: "Low" }
      ]
    };
  },
  props: {
    showDetailPageLink: {
      default: true
    }
  },
  mounted() {
    this.selectedOption = "high";
  },
  computed: {
    ...mapState("report", ["products", "summary"]),
    ...mapGetters("report", ["getChannels", "getSortedProducts"]),
    getItems() {
      if (this.getSortedProducts && this.getSortedProducts.length) {
        const max = this.getSortedProducts.length - 1;
        const range = this.getSortedProducts.length / 3;
        let start, end;
        switch (this.selectedOption) {
          case "high":
            start = 0;
            end = Math.floor(range);
            break;
          case "medium":
            start = Math.ceil(range);
            end = Math.floor(range * 2);
            break;
          case "low":
            start = Math.ceil(range * 2);
            end = max;
            break;
          default:
            break;
        }
        let products = [];
        this.getSortedProducts.forEach((el, index) => {
          if (products.length < 10 && index >= start && index <= end)
            products.push(el);
        });
        return products;
      }
      return [];
    }
  },
  methods: {
    getTotalSales(item) {
      return this.getChannels.reduce(
        (itemTot, channel) => itemTot + item[channel],
        0
      );
    }
  }
};
